
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/value-check",
      function () {
        return require("private-next-pages/value-check.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/value-check"])
      });
    }
  